<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Cấu hình thời gian làm việc</span></h3>
            </div>
            <div class="card-body">
                <el-table :data="dataList" border style="width: 100%" class="mt-4" v-loading="loading">
                    <!-- Thứ trong tuần -->
                    <el-table-column prop="cThu" label="Thứ" min-width="180" align="center" />
                    
                    <!-- Buổi sáng -->
                    <el-table-column label="Buổi sáng" align="center">
                        <el-table-column label="Bắt đầu" min-width="150" align="center">
                            <template #default="scope">
                                <el-time-select
                                    v-model="scope.row.cBatDauSang"
                                    start="05:00"
                                    step="00:15"
                                    end="12:00"
                                    placeholder="Chọn giờ"
                                    :disabled="scope.row.nTrangThai === 0"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column label="Kết thúc" min-width="150" align="center">
                            <template #default="scope">
                                <el-time-select
                                    v-model="scope.row.cKetThucSang"
                                    start="05:00"
                                    step="00:15"
                                    end="12:00"
                                    placeholder="Chọn giờ"
                                    :disabled="scope.row.nTrangThai === 0"
                                />
                            </template>
                        </el-table-column>
                    </el-table-column>

                    <!-- Buổi chiều -->
                    <el-table-column label="Buổi chiều" align="center">
                        <el-table-column label="Bắt đầu" min-width="150" align="center">
                            <template #default="scope">
                                <el-time-select
                                    v-model="scope.row.cBatDauChieu"
                                    start="12:00"
                                    step="00:15"
                                    end="18:00"
                                    placeholder="Chọn giờ"
                                    :disabled="scope.row.nTrangThai === 0"
                                />
                            </template>
                        </el-table-column>
                        <el-table-column label="Kết thúc" min-width="150" align="center">
                            <template #default="scope">
                                <el-time-select
                                    v-model="scope.row.cKetThucChieu"
                                    start="12:00"
                                    step="00:15"
                                    end="18:00"
                                    placeholder="Chọn giờ"
                                    :disabled="scope.row.nTrangThai === 0"
                                />
                            </template>
                        </el-table-column>
                    </el-table-column>

                    <!-- Trạng thái -->
                    <el-table-column label="Trạng thái" width="200" align="center">
                        <template #default="scope">
                            <el-switch
                                v-model="scope.row.nTrangThai"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="Hoạt động"
                                inactive-text="Nghỉ"
                            />
                        </template>
                    </el-table-column>
                </el-table>

                <!-- Nút lưu thay đổi -->
                <div class="d-flex justify-content-end mt-5">
                    <el-button type="primary" @click="saveChanges">
                        <i class="fas fa-save"></i> Lưu thay đổi
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { WorkingTimes } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
export default {
    name: 'workingTime',
    data() {
        return {
            store: useStore(),
            dataList: [],
            loading: false
        }
    },
    methods: {
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        },
        
        saveChanges() {
            // Validate thời gian
            let hasError = false;
            this.dataList.forEach(item => {
                if (item.nTrangThai === 1) {
                    // Kiểm tra buổi sáng
                    if (!item.cBatDauSang || !item.cKetThucSang) {
                        ElMessage.error(`${item.cThu}: Vui lòng nhập đủ thời gian buổi sáng`);
                        hasError = true;
                    } else if (item.cBatDauSang >= item.cKetThucSang) {
                        ElMessage.error(`${item.cThu}: Thời gian kết thúc buổi sáng phải sau thời gian bắt đầu`);
                        hasError = true;
                    }

                    // Kiểm tra buổi chiều
                    if (!item.cBatDauChieu || !item.cKetThucChieu) {
                        ElMessage.error(`${item.cThu}: Vui lòng nhập đủ thời gian buổi chiều`);
                        hasError = true;
                    } else if (item.cBatDauChieu >= item.cKetThucChieu) {
                        ElMessage.error(`${item.cThu}: Thời gian kết thúc buổi chiều phải sau thời gian bắt đầu`);
                        hasError = true;
                    }

                    // Kiểm tra thời gian giữa sáng và chiều
                    if (item.cKetThucSang >= item.cBatDauChieu) {
                        ElMessage.error(`${item.cThu}: Thời gian bắt đầu buổi chiều phải sau thời gian kết thúc buổi sáng`);
                        hasError = true;
                    }
                }
            });

            if (!hasError) {
                this.loading = true
                this.store.dispatch(WorkingTimes.saveWorkingTime, this.dataList).then(res => {
                    this.loading = false
                    if (res.code == 200)
                        ElMessage({ message: "Lưu thay đổi thành công", type: "success" });
                    else
                        ElMessage({ message: res.msg, type: "error" });
                }).catch((error) => {
                    this.loading = false                    
                    ElMessage({ message: "Có lỗi xảy ra. Vui lòng thử lại sau", type: "error" });
                })
            }
        },

        loadData() {
            this.store.dispatch(WorkingTimes.findPageWorkingTime).then(res => {
                if (res.code == 200) {
                    this.dataList = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Có lỗi xảy ra. Vui lòng thử lại sau", type: "error" });
            })
        }
    },
    mounted() {
        this.loadData()
    }
};
</script>
<style lang="scss"></style>